// src/pages/expense/_shared/VendorPanel.jsx
// ✅ 거래처/품목 DB 연동 공통화 — 환경/종합 파일럿(env/total/VendorPanel.jsx)에만
// 있던 "거래처 DB 입력" 새 창 버튼을 8개 사업(환경/종합·환경/소독·경영팀·용역사업·
// 카페 4개점) 공용 컴포넌트로 승격. 각 사업 폴더에 남아있던 구버전 VendorPanel.jsx는
// (구) 단독 페이지(ExpenseBusinessNew.jsx 등)가 계속 쓰므로 그대로 두고 손대지 않는다.
import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./VendorPanel.module.css";

export default function VendorPanel({ vendors, loadingVendors, onChange }) {
  const [list, setList] = useState([
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
  ]);

  // ✅ 자동완성 드롭다운을 document.body에 portal로 렌더 + position:fixed로 좌표를
  // 직접 계산한다. absolute+overflow:visible 방식은 조상 중 하나라도 overflow:hidden/
  // auto를 걸면(예: ExpenseItemPanel의 .sidePane은 overflow-x:hidden인데, CSS 스펙상
  // 한쪽 축이 visible이 아니면 반대 축의 visible도 auto로 강제 계산돼 잘림) 그 조상
  // 밑에서 잘린다 — 아예 DOM 트리 바깥(body)에 그려 어떤 조상의 overflow에도 영향받지
  // 않게 한다. 위치는 입력 input의 getBoundingClientRect() 기준이고, 스크롤/리사이즈
  // 시 재계산한다(scroll은 capture:true로 등록해 페이지 자체 스크롤뿐 아니라 다른
  // 스크롤 컨테이너 안에서 스크롤해도 추적됨).
  const inputRefs = useRef([]);
  const [rects, setRects] = useState([null, null, null, null, null]);
  const showKey = list.map((v) => (v.show ? 1 : 0)).join("");

  useEffect(() => {
    if (!showKey.includes("1")) {
      setRects([null, null, null, null, null]);
      return;
    }
    const update = () => {
      setRects(
        list.map((v, idx) => {
          if (!v.show) return null;
          const el = inputRefs.current[idx];
          if (!el) return null;
          const r = el.getBoundingClientRect();
          return { top: r.bottom, left: r.left, width: r.width };
        })
      );
    };
    update();
    window.addEventListener("scroll", update, true);
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update, true);
      window.removeEventListener("resize", update);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showKey]);

  const handleChange = (idx, value) => {
    const newList = [...list];
    newList[idx].name = value;
    newList[idx].id = null;
    newList[idx].show = true;
    newList[idx].highlight = 0;
    setList(newList);
    onChange && onChange(newList);
  };

  const handleKeyDown = (idx, e) => {
    const filtered = vendors.filter(vv =>
      vv.name.toLowerCase().includes(list[idx].name.toLowerCase())
    );

    if (!list[idx].show || !filtered.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      const newList = [...list];
      newList[idx].highlight =
        newList[idx].highlight < filtered.length - 1
          ? newList[idx].highlight + 1
          : 0;
      setList(newList);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const newList = [...list];
      newList[idx].highlight =
        newList[idx].highlight > 0
          ? newList[idx].highlight - 1
          : filtered.length - 1;
      setList(newList);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (list[idx].highlight >= 0) {
        const vv = filtered[list[idx].highlight];
        selectVendor(idx, vv);
      }
    } else if (e.key === "Escape") {
      const newList = [...list];
      newList[idx].show = false;
      setList(newList);
    }
  };

  const selectVendor = (idx, vendor) => {
    const newList = [...list];
    newList[idx].name = vendor.name;
    newList[idx].id = vendor.id;
    newList[idx].show = false;
    setList(newList);
    onChange && onChange(newList);
  };

  return (
    <div className={styles.sidePane}>
      <div className={styles.scrollWrap}>
        <table className={styles.vendorTable}>
          <thead>
            <tr>
              <th>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: 6 }}>
                  <span>거래처 1</span>
                  {/* ✅ 새 창으로 거래처 관리 페이지(/etc/vendors)를 열어 즉시 등록 —
                      크기를 등록 폼이 보이는 정도로 지정. 등록 후 이 작성 페이지로
                      돌아오면(창 포커스 복귀) 부모(ExpenseDraftNew)의 focus 리스너가
                      거래처 목록을 자동 재조회해 방금 등록한 거래처가 검색에 바로 잡힌다. */}
                  <button
                    type="button"
                    onClick={() => window.open("/etc/vendors", "vendorRegisterPopup", "width=1000,height=800")}
                    title="새 창에서 거래처 등록"
                    style={{
                      height: 18, padding: "0 6px", fontSize: 10, lineHeight: "16px",
                      whiteSpace: "nowrap", cursor: "pointer", border: "1px solid #ccc",
                      borderRadius: 4, background: "#fff", color: "#374151", fontWeight: 400,
                    }}
                  >
                    거래처 DB 입력
                  </button>
                </div>
              </th>
              <th>거래처 2</th>
              <th>거래처 3</th>
              <th>거래처 4</th>
              <th>거래처 5</th>
            </tr>
          </thead>
          <tbody>
            <tr className={styles.inputRow}>
              {list.map((v, idx) => {
                const filtered = vendors.filter(vv =>
                  vv.name.toLowerCase().includes(v.name.toLowerCase())
                );

                return (
                  <td key={idx} style={{ position: "relative" }}>

                    <input
                      ref={(el) => { inputRefs.current[idx] = el; }}
                      value={v.name}
                      onChange={(e) => handleChange(idx, e.target.value)}
                      onFocus={() => {
                        const newList = [...list];
                        newList[idx].show = true;
                        setList(newList);
                      }}
                      onKeyDown={(e) => handleKeyDown(idx, e)}
                      placeholder={`거래처 ${idx + 1}`}
                    />

                    {v.show && rects[idx] && createPortal(
                      <div
                        className={styles.vendorDropdown}
                        style={{ position: "fixed", top: rects[idx].top, left: rects[idx].left, width: rects[idx].width, marginTop: 2 }}
                      >
                        {loadingVendors && <div>불러오는 중...</div>}
                        {filtered.length ? (
                          filtered.map((vv, i) => (
                            <div
                              key={vv.id}
                              className={`${styles.vendorItem} ${i === v.highlight ? styles.activeItem : ""}`}
                              onClick={() => selectVendor(idx, vv)}
                            >
                              {vv.name}
                            </div>
                          ))
                        ) : (
                          <div className={styles.vendorItem}>일치하는 거래처 없음</div>
                        )}
                      </div>,
                      document.body
                    )}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
